<template>
    <div
        class="d-flex"
        v-bind:class="responsiveClass">
        <div class="p-2">
            {{ itemsPerPageMessage }}
        </div>
        <div v-show="selectorState === SELECTOR_STATE.Selector">
            <pc-select
                v-model="internalValue"
                class="items-per-page-selector-width"
                v-bind:alt-label="itemsPerPageMessage">
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="25">25</option>
                <option v-bind:value="CUSTOM_OPTION_VALUE">
                    {{ customItemsPerPageOption }}
                </option>
                <option
                    v-bind:value="customValue"
                    hidden>
                    {{ customValue }}
                </option>
            </pc-select>
        </div>
        <div v-show="selectorState === SELECTOR_STATE.CustomValueInput">
            <div class="d-flex">
                <pc-input
                    ref="customValueInput"
                    v-model="customValue"
                    v-bind:placeholder="customValuePlaceholder"
                    class="items-per-page-selector-width me-2"
                    v-bind:alt-label="itemsPerPageMessage"
                    v-bind:external-native-handlers="{ keyup: onCustomValueKeyUp }" />
                <div>
                    <pc-button
                        class="items-per-page-btn-width me-2"
                        primary
                        v-on:click="setCustomValue">
                        {{ okText }}
                    </pc-button>
                </div>
                <div>
                    <pc-button
                        class="items-per-page-btn-width"
                        v-on:click="cancelSetCustomValue">
                        {{ cancelText }}
                    </pc-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./pc-table.i18n";
    import { KEYS as COMMON_KEYS, NAMESPACE as COMMON_NAMESPACE } from "I18n/common.i18n";
    import { getResponsiveClasses } from "Responsive/manager";

    export const MIN_ITEMS_PER_PAGE = 5;
    export const MAX_ITEMS_PER_PAGE = 50;

    const CUSTOM_OPTION_VALUE = "CUSTOM";

    const SELECTOR_STATE = {
        Selector: "SELECTOR",
        CustomValueInput: "CUSTOM_VALUE_INPUT"
    };

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            modelValue: { type: Number, required: true }
        },
        emits: ["update:modelValue"],
        data() {
            return {
                selectorState: SELECTOR_STATE.Selector,
                customValue: this.modelValue.toString()
            };
        },
        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    if (value === CUSTOM_OPTION_VALUE) {
                        this.inputCustomValue();
                    } else {
                        const newValue = parseInt(value);
                        if (newValue && newValue >= MIN_ITEMS_PER_PAGE && newValue <= MAX_ITEMS_PER_PAGE) {
                            this.customValue = newValue.toString();
                            this.$emit("update:modelValue", newValue);
                            this.selectorState = SELECTOR_STATE.Selector;
                        } else {
                            this.cancelSetCustomValue();
                        }
                    }
                }
            },
            responsiveClass() {
                const config = { "justify-content": { xs: "center", md: "start" } };
                return getResponsiveClasses(this.viewport, config);
            },
            customValuePlaceholder() {
                return `${MIN_ITEMS_PER_PAGE} - ${MAX_ITEMS_PER_PAGE}`;
            },
            ...mapI18n(KEYS, NAMESPACE),
            ...mapI18n(COMMON_KEYS, COMMON_NAMESPACE)
        },
        created() {
            this.SELECTOR_STATE = SELECTOR_STATE;
            this.CUSTOM_OPTION_VALUE = CUSTOM_OPTION_VALUE;
        },
        methods: {
            async inputCustomValue() {
                this.customValue = "";
                this.selectorState = SELECTOR_STATE.CustomValueInput;
                // Wait for the input field to appear
                await this.$nextTick();
                this.$refs.customValueInput.$refs.input.focus();
            },
            onCustomValueKeyUp($event) {
                if ($event.code === "Enter") {
                    this.setCustomValue();
                }
                if ($event.code === "Escape") {
                    this.cancelSetCustomValue();
                }
            },
            setCustomValue() {
                this.internalValue = this.customValue;
            },
            cancelSetCustomValue() {
                this.customValue = this.modelValue.toString();
                this.selectorState = SELECTOR_STATE.Selector;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .items-per-page-selector-width {
        width: 75px;
    }

    .items-per-page-btn-width {
        min-width: 60px;
    }
</style>
